import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import CommentComponent from '@/views/Project/Comment/components/comment/comment.vue'
import CommentInputComponent from '@/views/Project/Comment/components/commentInput/commentInput.vue'
import CommentModel from '@/views/Project/Comment/models/comment'
import ThreadModel from '@/views/Project/Comment/models/thread'

@Component({
    components: { CommentComponent, CommentInputComponent },
    name: 'comments-view',
})
export default class CommentsView extends Mixins<MixinInterface>() {
    @Prop({ required: true }) threadId!: string
    @Prop({ default: false }) writableAttachmentToResource!: boolean

    thread: ThreadModel | null = null
    offset = 0
    limit = 10

    async mounted() {
        this.thread = await ThreadModel.get(this.threadId)
    }

    async handleComments($state: any) {
        if (this.thread) {
            let filters = {
                'filter[thread]': this.threadId,
                'page[offset]': this.offset,
                'page[limit]': this.limit,
            }

            let res: Array<CommentModel> = await this.thread.getComments(filters)
            if (res.length) {
                this.offset += this.limit
                $state.loaded()
            } else {
                $state.complete()
            }
        }
    }

    onPostComment(commentId: string) {
        const element = document.getElementById(commentId)
        if (element) element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
    }
}
